import { useState, useCallback } from 'react';
import { QueryKey } from 'react-query';

import { ID } from '../../../../../../../types';
import {
  UniversalFilterInvoicesValue,
  UniversalFilterInvoicesModes,
  UniversalFilterInvoicesFilterState,
  UniversalFilterInvoicesOnFilterStateChange,
  UniversalFilterInvoicesOnChange
} from '../../UniversalFilterInvoices.types';

import { useMountEffect } from '../../../../../../../common/hooks/useMountEffect';
import { useReactQueryState } from '../../../../../../../main/common/reactQuery/hooks/useReactQueryState';

import { useUniversalFilterInvoicesFilterState } from '../useUniversalFilterInvoicesFilterState';

import {
  UniversalFilterTemplateModeOption,
  UniversalFilterTemplateOnModeChange
} from '../../../../helpers/UniversalFilterTemplate';

import { filtersKeys } from '../../../../../../../locales/keys';

const defaultMode = UniversalFilterInvoicesModes.CONTAINS_ALL_OF;

const modeOptions: UniversalFilterTemplateModeOption<UniversalFilterInvoicesModes>[] =
  [
    // {
    //   value: UniversalFilterInvoicesModes.CONTAINS_ANY_OF,
    //   i18nText: filtersKeys.modes.containsAnyOf
    // }
    {
      value: UniversalFilterInvoicesModes.CONTAINS_ALL_OF,
      i18nText: filtersKeys.modes.containsAllOf
    }
    // {
    //   value: UniversalFilterInvoicesModes.CONTAINS_ONLY,
    //   i18nText: filtersKeys.modes.containsOnly
    // },
    // {
    //   value: UniversalFilterInvoicesModes.CONTAINS_NONE_OF,
    //   i18nText: filtersKeys.modes.containsNoneOf
    // },
    // {
    //   value: UniversalFilterInvoicesModes.DOES_NOT_CONTAIN_ANY_OF,
    //   i18nText: filtersKeys.modes.doesNotContainAnyOf
    // }
    // {
    //   value: UniversalFilterInvoicesModes.IS_EMPTY,
    //   i18nText: filtersKeys.modes.isEmpty
    // },
    // {
    //   value: UniversalFilterInvoicesModes.IS_NOT_EMPTY,
    //   i18nText: filtersKeys.modes.isNotEmpty
    // }
  ];

interface UniversalFilterInvoicesOptions {
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterInvoicesValue;
  onChange: UniversalFilterInvoicesOnChange;
}

function useUniversalFilterInvoices({
  filterStateCacheKey,
  filterValue,
  onChange
}: UniversalFilterInvoicesOptions) {
  const { value: savedState, setValue: saveState } =
    useReactQueryState<UniversalFilterInvoicesFilterState>(filterStateCacheKey);

  const { handleApplyFilterState, handleParseFilterValue } =
    useUniversalFilterInvoicesFilterState({
      onChange
    });

  const [filterState, setFilterState] =
    useState<UniversalFilterInvoicesFilterState>(
      savedState ||
        handleParseFilterValue(filterValue) || {
          mode: defaultMode,
          invoiceIds: []
        }
    );

  useMountEffect(() => {
    handleApplyFilterState(filterState);
  });

  const handleFilterStateChange =
    useCallback<UniversalFilterInvoicesOnFilterStateChange>(
      (state) => {
        setFilterState(state);
        handleApplyFilterState(state);
        saveState(state);
      },
      [handleApplyFilterState, saveState]
    );

  const handleModeChange = useCallback<
    UniversalFilterTemplateOnModeChange<UniversalFilterInvoicesModes>
  >(
    (mode) => {
      handleFilterStateChange({
        mode,
        invoiceIds: filterState.invoiceIds || []
      });
    },
    [filterState, handleFilterStateChange]
  );

  const handleUserIdsChange = useCallback<(invoiceIds: ID[]) => void>(
    (invoiceIds) => {
      handleFilterStateChange({
        mode: filterState.mode,
        invoiceIds: invoiceIds || []
      });
    },
    [filterState, handleFilterStateChange]
  );

  return {
    modeOptions,
    filterState,
    handleModeChange,
    handleUserIdsChange
  };
}

export default useUniversalFilterInvoices;
